<div #gridContainer class="igx-grid-container"
  [ngClass]="{'fullscreen-active': isFullscreen}"
  (clickOutside)="onClickedOutside($event)">
  <igx-grid
    igxPreventDocumentScroll
    #supplementalPremiumsGrid
    [data]="initialData"
    [autoGenerate]="false"
    height="90%"
    [rowEditable]="false"
    paste-handler
    (onDataProcessed)="updateRecords($event)"
    [primaryKey]="'0'"
    [clipboardOptions]="premiumReportService.getClipboardOptions"
    (cellEditEnter)="editStart($event)"
    (cellEditDone)="onEditCompleted($event)"
    (selected)="onCellSelect($event)"
    [emptyGridMessage]="'.'"
    (gridKeydown)="enterGridEditMode($event)"
    (keydown)="enterEditMode($event)"
    [cellSelection]="'multiple'"
    [ngClass]="{'igx-grid-fs': isFullscreen}"
  >
    <igx-column
      *ngFor="let c of columns;; let last = last"
      [field]="c.columnNumber.toString()"
      [header]="c.columnName"
      [pinned]="c.IsPinned"
      [cellClasses]="cellClass"
      [editable]="isReadOnly == true ? false : c.editable"
      [width]="getColWidth(c.columnNumber)"
      [dataType]="c.dataType"
      [resizable]="true"
      [hidden] = "c.hidden"
    >
      <ng-template igxHeader let-column>
        <div>
          {{ column.header }}
        </div>
      </ng-template>
      <ng-template igxCellEditor let-cell="cell">
        <igx-input-group>
          <input
            igxInput
            [igxFocus]="true"
            (focus)="onCellFocus($event)"
            [(ngModel)]="cell.editValue"
            class="input-selection"
            type="number"
            [ngClass]="{ 'no-spinners': true }"
            id="input"
          />
        </igx-input-group>
      </ng-template>
<ng-template *ngIf="last" igxCell let-cell="cell">
  <span class="cursor-style"
    [igxTooltipTarget]="tooltipRef"
    [overlaySettings]="settings"
    (tooltipShow)="tooltipRef.context = cell"
  >
    {{ cell.value | number:'1.0-0' }}
  </span>
</ng-template>
    </igx-column>
  </igx-grid>
  <div #tooltipRef="tooltip" igxTooltip>
  <ng-container *ngIf="tooltipRef.context">
     <ng-container *ngIf="getTooltipValue(tooltipRef.context) as tooltipData">
      <div class="tooltip-content">
        <div class="tooltip-heading">
          <span>Total {{ 'premium.supplemental' | label }} {{tooltipData.state | number:'1.0-0' }}</span>
        </div>
        <div class="tooltip-line">
          <span class="label">{{ 'premium.supplemental' | label }}</span>
          <span class="dash">:</span>
          <span class="value">{{ tooltipData.supplemental | number:'1.0-0' }}</span>
        </div>
        <div class="tooltip-line">
          <span class="label">{{ 'premium.userDefinedSupplemental' | label }}</span>
          <span class="dash">:</span>
          <span class="value">{{ tooltipData.userDefinedSupplemental | number:'1.0-0' }}</span>
        </div>
        <div class="tooltip-line">
          <span class="label">Total</span>
          <span class="dash">:</span>
          <span class="value">{{ tooltipData.total | number:'1.0-0' }}</span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
  <div id="direct" style="width: 100%"></div>
  <div id="supplemental"></div>
</div>
